import { useSuspenseQuery } from "@tanstack/react-query";
import { orderHistoryApi } from "@/features/my-order/features/order-history/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const useGetOrderHistoryDetail = (orderSheetSetId?: string | null) => {
  const identity = useIdentity();

  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];

  const canFetch = Boolean(orderSheetSetId && companyId);

  return useSuspenseQuery({
    queryKey: [
      "order-history",
      "detail",
      companyId,
      companyType,
      orderSheetSetId,
    ],
    queryFn: () => {
      if (!canFetch) return; // ✅ 여기서 확실히 차단
      return orderHistoryApi.getOrderHistoryDetail({
        companyId,
        companyType,
        orderSheetSetId: +orderSheetSetId!, // canFetch로 보장
      });
    },
  });
};

export default useGetOrderHistoryDetail;
